import { createLazyComponent, LazyImport, LazyModule } from 'owa-bundling';
// Import orchestrators so they get registered
import './orchestrators/refreshPanelAdsOrchestrators';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "AdsPanel" */ './lazyIndex');
});
export var AdsPanel = createLazyComponent(lazyModule, function (m) { return m.AdsPanel; });
export var lazyRefreshAd = new LazyImport(lazyModule, function (m) { return m.refresh; });
//# sourceMappingURL=index.js.map